<template>
  <base-container ref="container">
    <ArtisanGrid
      ref="schedule"
      metaKey="JcScheduleInfo"
      :leftOption="option"
      :metaInited="metaInited"
      :handleQuery="handleQuery"
    >
      <template #status="{ row }">
        <el-tag :type="statusMap[row.status].type" size="small">
          {{ statusMap[row.status].label }}
        </el-tag>
      </template>
      <template #endPointForm="{ row }">
        <el-time-select
          placeholder="结束时间"
          v-model="row.endPoint"
          :picker-options="{
            start: '00:00',
            step: '00:30',
            end: '24:00',
            minTime: row.startPoint,
          }"
        >
        </el-time-select>
      </template>
    </ArtisanGrid>
  </base-container>
</template>

<script>
import Constant from "@/config/constant.js";
export default {
  data() {
    return {
      option: {
        width: "20%",
        title: "检查资源",
        treeKey: "AuthResourceOption",
        searchField: "resourceId",
      },
      statusMap: {
        normal: {
          label: "未约满",
          type: "success",
        },
        full: {
          label: "已约满",
          type: "warning",
        },
        stop: {
          label: "已停诊",
          type: "danger",
        },
      },
    };
  },
  methods: {
    handleQuery(param) {
      if (param.scheduleDate && param.scheduleDate.length) {
        param.scheduleDate = param.scheduleDate.join(",");
      }
      return param;
    },
    metaInited(option) {
      option.columns.forEach((c) => {
        if (c.code == "weekNo") {
          c.dicData = Constant.weeks.map((c) => {
            return {
              value: c.weekNo,
              label: c.name,
            };
          });
        } else if (c.code == "clinicType") {
          c.dicData = [
            {
              value: "",
              label: "不限",
            },
            {
              value: "outpatient",
              label: "门诊",
            },
            {
              value: "inpatient",
              label: "住院",
            },
          ];
        } else if (c.code == "endPoint") {
          c.isSlot = true;
        }
      });
      return option;
    },
  },
};
</script>

<style scoped></style>
